import zh from "./zh";
import es from "./es";
import en from "./en";
import pt from "./pt";

const dicts = { zh, es, en, pt };

// Public pages (shop/rider/track) set a scoped override so customers/riders
// see Spanish by default regardless of the merchant's app_lang.
import { curSym } from "../utils/cur";
let trOverride = null;
export function setTrLang(lang) { trOverride = lang || null; }

// Global translator usable anywhere (module scope, toasts, non-component code).
// Reads current language at call time; LangProvider rerenders the tree on switch.
export function tr(key) {
  const lang = trOverride || localStorage.getItem("app_lang") || "zh";
  return curText((dicts[lang] && dicts[lang][key]) || dicts.zh[key] || key);
}

// 💱 shop display symbol: labels like "销售额($)" → "销售额(¥)" for shops pricing in RMB
export function curText(s) {
  const sym = curSym();
  return sym === "$" || typeof s !== "string" || !s.includes("$") ? s : s.split("$").join(sym);
}
